import React, { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { HowItWorksCta } from './HowItWorksCta';
import { HowItWorksHero } from './HowItWorksHero';
import { ProgressOverview, WalkthroughSections } from './HowItWorksSteps';

const HowItWorks = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <HowItWorksHero />
      <ProgressOverview />
      <WalkthroughSections />
      <HowItWorksCta onGetStarted={() => navigate('/job-analysis')} />
    </Box>
  );
};

export { HowItWorks };
